// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O6kr","importantInfo":"styles_importantInfo__2fxgj"};